import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/starFilled.svg';

export const IconStarFilled = createIconComponent(Icon);
